import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getAllSectors } from '@api/sectors';

import { extractQueryParams } from '@utils/common';

import { ALL_SECTORS } from '@constants/queryKeys';

export const useQueryAllSectors = () => {
	const {
		accessPermission: {
			networkOperatorTelecomSitesAttributeUpdater,
			networkOperatorTelecomSitesViewer,
			networkOperatorKpiViewer,
			networkOperatorKpiUpdater,
		},
	} = useAppSelector(auth);

	const isSectorsAvailable = (
		networkOperatorTelecomSitesAttributeUpdater ||
		networkOperatorTelecomSitesViewer ||
		networkOperatorKpiViewer ||
		networkOperatorKpiUpdater
	);

	const { data, isLoading, isFetching, isInitialLoading } = useQuery({
		queryKey: [ALL_SECTORS],
		queryFn: extractQueryParams(getAllSectors),
		enabled: [isSectorsAvailable],
	});

	return {
		allSectors: data?.items || [],
		isInitialLoading,
		isLoading,
		isFetching,
	};
};
